export const getPaulistaArea = () => {

    const paulistaKML = [{
        lng: -46.688778,
        lat: -23.566947,
    }, {
        lng: -46.687104,
        lat: -23.569563,
    }, {
        lng: -46.688059,
        lat: -23.570119,
    }, {
        lng: -46.687791,
        lat: -23.570527,
    }, {
        lng: -46.687807,
        lat: -23.57062,
    }, {
        lng: -46.687753,
        lat: -23.570669,
    }, {
        lng: -46.687673,
        lat: -23.570684,
    }, {
        lng: -46.685564,
        lat: -23.57415,
    }, {
        lng: -46.68579,
        lat: -23.57416,
    }, {
        lng: -46.686208,
        lat: -23.574829,
    }, {
        lng: -46.686262,
        lat: -23.575119,
    }, {
        lng: -46.683521,
        lat: -23.574898,
    }, {
        lng: -46.682995,
        lat: -23.574878,
    }, {
        lng: -46.682856,
        lat: -23.574893,
    }, {
        lng: -46.682727,
        lat: -23.574986,
    }, {
        lng: -46.682636,
        lat: -23.574942,
    }, {
        lng: -46.682614,
        lat: -23.574873,
    }, {
        lng: -46.682255,
        lat: -23.57479,
    }, {
        lng: -46.681949,
        lat: -23.57534,
    }, {
        lng: -46.68189,
        lat: -23.575458,
    }, {
        lng: -46.681826,
        lat: -23.575645,
    }, {
        lng: -46.681777,
        lat: -23.57597,
    }, {
        lng: -46.681761,
        lat: -23.576255,
    }, {
        lng: -46.681766,
        lat: -23.576461,
    }, {
        lng: -46.681847,
        lat: -23.576781,
    }, {
        lng: -46.681868,
        lat: -23.576997,
    }, {
        lng: -46.681863,
        lat: -23.577199,
    }, {
        lng: -46.681826,
        lat: -23.577459,
    }, {
        lng: -46.681788,
        lat: -23.577543,
    }, {
        lng: -46.681724,
        lat: -23.577715,
    }, {
        lng: -46.681622,
        lat: -23.577892,
    }, {
        lng: -46.681332,
        lat: -23.578251,
    }, {
        lng: -46.679449,
        lat: -23.579922,
    }, {
        lng: -46.679379,
        lat: -23.580036,
    }, {
        lng: -46.679159,
        lat: -23.58068,
    }, {
        lng: -46.678934,
        lat: -23.580566,
    }, {
        lng: -46.678773,
        lat: -23.580463,
    }, {
        lng: -46.678484,
        lat: -23.580306,
    }, {
        lng: -46.678124,
        lat: -23.580144,
    }, {
        lng: -46.677488,
        lat: -23.579748,
    }, {
        lng: -46.676424,
        lat: -23.579185,
    }, {
        lng: -46.673763,
        lat: -23.577735,
    }, {
        lng: -46.673253,
        lat: -23.577435,
    }, {
        lng: -46.673012,
        lat: -23.577351,
    }, {
        lng: -46.672926,
        lat: -23.577287,
    }, {
        lng: -46.672733,
        lat: -23.577282,
    }, {
        lng: -46.672497,
        lat: -23.577253,
    }, {
        lng: -46.672041,
        lat: -23.577272,
    }, {
        lng: -46.671655,
        lat: -23.577218,
    }, {
        lng: -46.671499,
        lat: -23.577179,
    }, {
        lng: -46.670936,
        lat: -23.579716,
    }, {
        lng: -46.67078,
        lat: -23.580945,
    }, {
        lng: -46.670791,
        lat: -23.581112,
    }, {
        lng: -46.670791,
        lat: -23.581191,
    }, {
        lng: -46.670399,
        lat: -23.583285,
    }, {
        lng: -46.670147,
        lat: -23.583472,
    }, {
        lng: -46.670051,
        lat: -23.58387,
    }, {
        lng: -46.669868,
        lat: -23.584087,
    }, {
        lng: -46.666006,
        lat: -23.58185,
    }, {
        lng: -46.661725,
        lat: -23.579372,
    }, {
        lng: -46.661586,
        lat: -23.579549,
    }, {
        lng: -46.661505,
        lat: -23.579809,
    }, {
        lng: -46.661146,
        lat: -23.580252,
    }, {
        lng: -46.661232,
        lat: -23.580394,
    }, {
        lng: -46.660856,
        lat: -23.580517,
    }, {
        lng: -46.658088,
        lat: -23.58184,
    }, {
        lng: -46.65753,
        lat: -23.582233,
    }, {
        lng: -46.655706,
        lat: -23.585458,
    }, {
        lng: -46.655186,
        lat: -23.585886,
    }, {
        lng: -46.653174,
        lat: -23.584746,
    }, {
        lng: -46.653072,
        lat: -23.584328,
    }, {
        lng: -46.652976,
        lat: -23.584082,
    }, {
        lng: -46.652724,
        lat: -23.583698,
    }, {
        lng: -46.65252,
        lat: -23.583438,
    }, {
        lng: -46.652407,
        lat: -23.583276,
    }, {
        lng: -46.651983,
        lat: -23.582941,
    }, {
        lng: -46.650465,
        lat: -23.581879,
    }, {
        lng: -46.648437,
        lat: -23.580488,
    }, {
        lng: -46.646158,
        lat: -23.578752,
    }, {
        lng: -46.644242,
        lat: -23.577386,
    }, {
        lng: -46.641635,
        lat: -23.575596,
    }, {
        lng: -46.641351,
        lat: -23.575394,
    }, {
        lng: -46.641018,
        lat: -23.574005,
    }, {
        lng: -46.640796,
        lat: -23.572503,
    }, {
        lng: -46.640524,
        lat: -23.56946,
    }, {
        lng: -46.640387,
        lat: -23.567339,
    }, {
        lng: -46.640638,
        lat: -23.565808,
    }, {
        lng: -46.64087,
        lat: -23.565425,
    }, {
        lng: -46.641016,
        lat: -23.569723,
    }, {
        lng: -46.641602,
        lat: -23.573235,
    }, {
        lng: -46.642767,
        lat: -23.571849,
    }, {
        lng: -46.643711,
        lat: -23.571584,
    }, {
        lng: -46.643835,
        lat: -23.568486,
    }, {
        lng: -46.645106,
        lat: -23.564597,
    }, {
        lng: -46.645122,
        lat: -23.564297,
    }, {
        lng: -46.645691,
        lat: -23.562753,
    }, {
        lng: -46.645895,
        lat: -23.560968,
    }, {
        lng: -46.646158,
        lat: -23.560909,
    }, {
        lng: -46.646195,
        lat: -23.560875,
    }, {
        lng: -46.645077,
        lat: -23.560021,
    }, {
        lng: -46.645063,
        lat: -23.55966,
    }, {
        lng: -46.645168,
        lat: -23.558571,
    }, {
        lng: -46.645867,
        lat: -23.552147,
    }, {
        lng: -46.646266,
        lat: -23.551545,
    }, {
        lng: -46.646461,
        lat: -23.551558,
    }, {
        lng: -46.646677,
        lat: -23.551682,
    }, {
        lng: -46.646463,
        lat: -23.557757,
    }, {
        lng: -46.648362,
        lat: -23.557934,
    }, {
        lng: -46.648598,
        lat: -23.558622,
    }, {
        lng: -46.649108,
        lat: -23.560988,
    }, {
        lng: -46.649264,
        lat: -23.564056,
    }, {
        lng: -46.649306,
        lat: -23.564071,
    }, {
        lng: -46.650524,
        lat: -23.56296,
    }, {
        lng: -46.651388,
        lat: -23.563899,
    }, {
        lng: -46.656039,
        lat: -23.559862,
    }, {
        lng: -46.656162,
        lat: -23.559645,
    }, {
        lng: -46.656173,
        lat: -23.557644,
    }, {
        lng: -46.657374,
        lat: -23.556887,
    }, {
        lng: -46.660727,
        lat: -23.554089,
    }, {
        lng: -46.659118,
        lat: -23.552953,
    }, {
        lng: -46.655754,
        lat: -23.551109,
    }, {
        lng: -46.652949,
        lat: -23.549574,
    }, {
        lng: -46.652171,
        lat: -23.549171,
    }, {
        lng: -46.653587,
        lat: -23.547086,
    }, {
        lng: -46.653571,
        lat: -23.547052,
    }, {
        lng: -46.652864,
        lat: -23.546225,
    }, {
        lng: -46.652158,
        lat: -23.545438,
    }, {
        lng: -46.651542,
        lat: -23.545922,
    }, {
        lng: -46.649185,
        lat: -23.547808,
    }, {
        lng: -46.649151,
        lat: -23.547797,
    }, {
        lng: -46.649145,
        lat: -23.547769,
    }, {
        lng: -46.651484,
        lat: -23.545883,
    }, {
        lng: -46.652121,
        lat: -23.545376,
    }, {
        lng: -46.652085,
        lat: -23.545254,
    }, {
        lng: -46.654531,
        lat: -23.544366,
    }, {
        lng: -46.656618,
        lat: -23.54357,
    }, {
        lng: -46.658839,
        lat: -23.542212,
    }, {
        lng: -46.661414,
        lat: -23.54053,
    }, {
        lng: -46.661414,
        lat: -23.540058,
    }, {
        lng: -46.661875,
        lat: -23.540058,
    }, {
        lng: -46.662144,
        lat: -23.540166,
    }, {
        lng: -46.662154,
        lat: -23.540452,
    }, {
        lng: -46.662122,
        lat: -23.540648,
    }, {
        lng: -46.662315,
        lat: -23.540835,
    }, {
        lng: -46.663463,
        lat: -23.541553,
    }, {
        lng: -46.664289,
        lat: -23.542793,
    }, {
        lng: -46.664847,
        lat: -23.544111,
    }, {
        lng: -46.665083,
        lat: -23.544347,
    }, {
        lng: -46.665899,
        lat: -23.544583,
    }, {
        lng: -46.666456,
        lat: -23.544838,
    }, {
        lng: -46.667669,
        lat: -23.545153,
    }, {
        lng: -46.669085,
        lat: -23.545714,
    }, {
        lng: -46.670018,
        lat: -23.546225,
    }, {
        lng: -46.67122,
        lat: -23.546963,
    }, {
        lng: -46.672036,
        lat: -23.547661,
    }, {
        lng: -46.672894,
        lat: -23.548094,
    }, {
        lng: -46.673913,
        lat: -23.548232,
    }, {
        lng: -46.674203,
        lat: -23.548281,
    }, {
        lng: -46.67504,
        lat: -23.5501,
    }, {
        lng: -46.675372,
        lat: -23.550248,
    }, {
        lng: -46.675308,
        lat: -23.550484,
    }, {
        lng: -46.675565,
        lat: -23.551094,
    }, {
        lng: -46.675898,
        lat: -23.551674,
    }, {
        lng: -46.676209,
        lat: -23.551605,
    }, {
        lng: -46.677668,
        lat: -23.550622,
    }, {
        lng: -46.67785,
        lat: -23.551123,
    }, {
        lng: -46.678451,
        lat: -23.552058,
    }, {
        lng: -46.680039,
        lat: -23.553926,
    }, {
        lng: -46.68137,
        lat: -23.555106,
    }, {
        lng: -46.681472,
        lat: -23.555215,
    }, {
        lng: -46.682646,
        lat: -23.555908,
    }, {
        lng: -46.682947,
        lat: -23.556139,
    }, {
        lng: -46.683075,
        lat: -23.556444,
    }, {
        lng: -46.683065,
        lat: -23.556926,
    }, {
        lng: -46.682378,
        lat: -23.557949,
    }, {
        lng: -46.682239,
        lat: -23.558185,
    }, {
        lng: -46.682024,
        lat: -23.558991,
    }, {
        lng: -46.680179,
        lat: -23.561568,
    }, {
        lng: -46.688869,
        lat: -23.566741,
    }, {
        lng: -46.688778,
        lat: -23.566947,
    }];
    return paulistaKML;
}

export const getIguatemiJKArea = () => {
    const iguatemijkKML = [{
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6648471,
        lat: -23.5937523
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6641014,
        lat: -23.5872423
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.6631277,
        lat: -23.5817339
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.661725,
        lat: -23.579372
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.670051,
        lat: -23.58387
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.671655,
        lat: -23.577218
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.673253,
        lat: -23.577435
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.678934,
        lat: -23.580566
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681788,
        lat: -23.577543
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.681777,
        lat: -23.57597
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.682255,
        lat: -23.57479
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.686262,
        lat: -23.575119
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.685564,
        lat: -23.57415
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.688059,
        lat: -23.570119
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687209,
        lat: -23.569528
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687472,
        lat: -23.569161
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.687807,
        lat: -23.568652
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.688483,
        lat: -23.567592
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.6898243,
        lat: -23.5656717
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690408,
        lat: -23.564904
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.690818,
        lat: -23.564377
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691184,
        lat: -23.563803
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691943,
        lat: -23.562704
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.691833,
        lat: -23.562453
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.69176,
        lat: -23.562187
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.692431,
        lat: -23.561784
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.6929891,
        lat: -23.5614056
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.693718,
        lat: -23.560712
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.6953166,
        lat: -23.5599549
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.696197,
        lat: -23.558637
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.6988799,
        lat: -23.5578651
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.699426,
        lat: -23.555756
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.704361,
        lat: -23.55309
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.705155,
        lat: -23.552284
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.706067,
        lat: -23.551468
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.708862,
        lat: -23.549471
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.710134,
        lat: -23.548537
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.71163,
        lat: -23.547474
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.712998,
        lat: -23.546245
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713202,
        lat: -23.546093
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713213,
        lat: -23.545891
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713138,
        lat: -23.545665
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.713685,
        lat: -23.545576
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715133,
        lat: -23.543894
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.715951,
        lat: -23.542532
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716662,
        lat: -23.541111
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.716941,
        lat: -23.540821
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717697,
        lat: -23.540589
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.717904,
        lat: -23.540464
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718035,
        lat: -23.540103
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718392,
        lat: -23.539475
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718647,
        lat: -23.539153
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.718665,
        lat: -23.539135
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719071,
        lat: -23.538735
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719312,
        lat: -23.538278
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719414,
        lat: -23.53787
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719735,
        lat: -23.538066
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719741,
        lat: -23.538888
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719706,
        lat: -23.539494
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719699,
        lat: -23.539606
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.719326,
        lat: -23.541711
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.718985,
        lat: -23.543781
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.719266,
        lat: -23.544637
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.722191,
        lat: -23.54386
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.724233,
        lat: -23.543668
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.725351,
        lat: -23.543257
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726554,
        lat: -23.542532
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.726704,
        lat: -23.543019
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.725491,
        lat: -23.543808
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.722202,
        lat: -23.544439
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.719213,
        lat: -23.545306
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717923,
        lat: -23.547219
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717711,
        lat: -23.548306
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.717896,
        lat: -23.548576
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718137,
        lat: -23.54865
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.718304,
        lat: -23.548537
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.7187,
        lat: -23.549132
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.719618,
        lat: -23.549117
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.721549,
        lat: -23.548212
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.723577,
        lat: -23.551777
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711475,
        lat: -23.55789
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711676,
        lat: -23.558261
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.711995,
        lat: -23.558829
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712158,
        lat: -23.559257
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712199,
        lat: -23.559847
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712094,
        lat: -23.56097
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.712069,
        lat: -23.561798
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71202,
        lat: -23.563149
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.71189,
        lat: -23.56589
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711673,
        lat: -23.571333
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711581,
        lat: -23.571914
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711413,
        lat: -23.572609
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711365,
        lat: -23.572904
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.711796,
        lat: -23.572995
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712199,
        lat: -23.573086
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712636,
        lat: -23.573211
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.712446,
        lat: -23.573767
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.71225,
        lat: -23.574432
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712102,
        lat: -23.575043
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712234,
        lat: -23.575362
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712586,
        lat: -23.575593
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712458,
        lat: -23.575763
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.712958,
        lat: -23.576019
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714025,
        lat: -23.576278
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714458,
        lat: -23.576855
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.714849,
        lat: -23.577393
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.715797,
        lat: -23.578274
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.719468,
        lat: -23.578852
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.721064,
        lat: -23.580096
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.723648,
        lat: -23.581027
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.724866,
        lat: -23.581825
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.728745,
        lat: -23.584885
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.730203,
        lat: -23.58564
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731704,
        lat: -23.586592
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.731894,
        lat: -23.587001
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.730148,
        lat: -23.58601
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.729221,
        lat: -23.585554
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.727929,
        lat: -23.58494
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.724736,
        lat: -23.582349
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.721715,
        lat: -23.580711
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720928,
        lat: -23.580425
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.720312,
        lat: -23.58002
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.718952,
        lat: -23.579172
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.71718,
        lat: -23.578944
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.715666,
        lat: -23.57856
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.713964,
        lat: -23.577179
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.71251,
        lat: -23.578011
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.711104,
        lat: -23.578838
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710921,
        lat: -23.579329
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.710839,
        lat: -23.57962
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711339,
        lat: -23.58036
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.711858,
        lat: -23.581191
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712242,
        lat: -23.581669
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.712786,
        lat: -23.582108
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.71344,
        lat: -23.58244
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.714107,
        lat: -23.582731
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.715436,
        lat: -23.583298
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.716238,
        lat: -23.583615
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.717043,
        lat: -23.58392
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.7177,
        lat: -23.584345
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.718422,
        lat: -23.584618
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.719477,
        lat: -23.584781
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.720548,
        lat: -23.585028
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.721558,
        lat: -23.585407
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.722591,
        lat: -23.585794
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.724615,
        lat: -23.586572
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725454,
        lat: -23.586911
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.725842,
        lat: -23.58706
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.726208,
        lat: -23.587289
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.727586,
        lat: -23.588212
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728456,
        lat: -23.588732
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.728875,
        lat: -23.588962
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.729262,
        lat: -23.58929
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.731866,
        lat: -23.592063
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.733524,
        lat: -23.592749
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734378,
        lat: -23.592954
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.734053,
        lat: -23.593072
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.733432,
        lat: -23.592957
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.73177,
        lat: -23.592222
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.728816,
        lat: -23.589212
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.72583,
        lat: -23.587284
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724456,
        lat: -23.586746
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.724056,
        lat: -23.58745
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723768,
        lat: -23.587898
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.723208,
        lat: -23.588769
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.722083,
        lat: -23.590522
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721709,
        lat: -23.592138
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.721369,
        lat: -23.593568
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.720828,
        lat: -23.594165
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.72061,
        lat: -23.594558
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.720381,
        lat: -23.596083
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.7202,
        lat: -23.597559
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.72035,
        lat: -23.598086
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.720229,
        lat: -23.598331
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.71991,
        lat: -23.598447
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719714,
        lat: -23.59856
    }, {
        lng: -46.719496,
        lat: -23.598816
    }, {
        lng: -46.719338,
        lat: -23.599111
    }, {
        lng: -46.719079,
        lat: -23.599854
    }, {
        lng: -46.718593,
        lat: -23.601295
    }, {
        lng: -46.718625,
        lat: -23.601848
    }, {
        lng: -46.718785,
        lat: -23.602895
    }, {
        lng: -46.718966,
        lat: -23.60406
    }, {
        lng: -46.719323,
        lat: -23.604141
    }, {
        lng: -46.719457,
        lat: -23.604311
    }, {
        lng: -46.719317,
        lat: -23.604911
    }, {
        lng: -46.719279,
        lat: -23.605529
    }, {
        lng: -46.719358,
        lat: -23.606078
    }, {
        lng: -46.719742,
        lat: -23.606793
    }, {
        lng: -46.719974,
        lat: -23.607816
    }, {
        lng: -46.719983,
        lat: -23.609428
    }, {
        lng: -46.720245,
        lat: -23.610581
    }, {
        lng: -46.720345,
        lat: -23.61071
    }, {
        lng: -46.721002,
        lat: -23.611112
    }, {
        lng: -46.72141,
        lat: -23.611266
    }, {
        lng: -46.721943,
        lat: -23.611335
    }, {
        lng: -46.721855,
        lat: -23.612117
    }, {
        lng: -46.721345,
        lat: -23.612109
    }, {
        lng: -46.720943,
        lat: -23.612087
    }, {
        lng: -46.719427,
        lat: -23.611421
    }, {
        lng: -46.718274,
        lat: -23.61151
    }, {
        lng: -46.717612,
        lat: -23.611812
    }, {
        lng: -46.716446,
        lat: -23.612893
    }, {
        lng: -46.715206,
        lat: -23.613911
    }, {
        lng: -46.714852,
        lat: -23.614048
    }, {
        lng: -46.714339,
        lat: -23.613921
    }, {
        lng: -46.71412,
        lat: -23.613938
    }, {
        lng: -46.714036,
        lat: -23.614481
    }, {
        lng: -46.713437,
        lat: -23.615415
    }, {
        lng: -46.712604,
        lat: -23.616575
    }, {
        lng: -46.712183,
        lat: -23.61715
    }, {
        lng: -46.71229,
        lat: -23.618177
    }, {
        lng: -46.711947,
        lat: -23.619263
    }, {
        lng: -46.710659,
        lat: -23.620895
    }, {
        lng: -46.708814,
        lat: -23.621721
    }, {
        lng: -46.706507,
        lat: -23.622114
    }, {
        lng: -46.70449,
        lat: -23.621347
    }, {
        lng: -46.703857,
        lat: -23.620787
    }, {
        lng: -46.70236,
        lat: -23.618875
    }, {
        lng: -46.702093,
        lat: -23.619565
    }, {
        lng: -46.702426,
        lat: -23.62226
    }, {
        lng: -46.708861,
        lat: -23.625143
    }, {
        lng: -46.711691,
        lat: -23.627319
    }, {
        lng: -46.710999,
        lat: -23.627737
    }, {
        lng: -46.70975,
        lat: -23.628746
    }, {
        lng: -46.707012,
        lat: -23.631057
    }, {
        lng: -46.703691,
        lat: -23.633078
    }, {
        lng: -46.697877,
        lat: -23.636173
    }, {
        lng: -46.695668,
        lat: -23.637263
    }, {
        lng: -46.693997,
        lat: -23.638145
    }, {
        lng: -46.682249,
        lat: -23.625309
    }, {
        lng: -46.67909,
        lat: -23.621775
    }, {
        lng: -46.678153,
        lat: -23.622566
    }, {
        lng: -46.67726,
        lat: -23.62371
    }, {
        lng: -46.676538,
        lat: -23.625267
    }, {
        lng: -46.675602,
        lat: -23.626667
    }, {
        lng: -46.673895,
        lat: -23.629122
    }, {
        lng: -46.669109,
        lat: -23.63348
    }, {
        lng: -46.669105,
        lat: -23.6317
    }, {
        lng: -46.668798,
        lat: -23.630733
    }, {
        lng: -46.668011,
        lat: -23.629783
    }, {
        lng: -46.667383,
        lat: -23.629416
    }, {
        lng: -46.662735,
        lat: -23.628288
    }, {
        lng: -46.662367,
        lat: -23.628039
    }, {
        lng: -46.661758,
        lat: -23.6275
    }, {
        lng: -46.661614,
        lat: -23.626973
    }, {
        lng: -46.661713,
        lat: -23.623914
    }, {
        lng: -46.662125,
        lat: -23.618267
    }, {
        lng: -46.661748,
        lat: -23.617276
    }, {
        lng: -46.652284,
        lat: -23.607427
    }, {
        lng: -46.651672,
        lat: -23.606228
    }, {
        lng: -46.651286,
        lat: -23.601755
    }, {
        lng: -46.650749,
        lat: -23.595861
    }, {
        lng: -46.650554,
        lat: -23.593344
    }, {
        lng: -46.650674,
        lat: -23.592336
    }, {
        lng: -46.65249,
        lat: -23.590996
    }, {
        lng: -46.653812,
        lat: -23.590463
    }, {
        lng: -46.654207,
        lat: -23.590286
    }, {
        lng: -46.654564,
        lat: -23.590281
    }, {
        lng: -46.65495,
        lat: -23.590382
    }, {
        lng: -46.655095,
        lat: -23.59063
    }, {
        lng: -46.654703,
        lat: -23.591854
    }, {
        lng: -46.655954,
        lat: -23.592246
    }, {
        lng: -46.657769,
        lat: -23.592865
    }, {
        lng: -46.661033,
        lat: -23.593963
    }, {
        lng: -46.661301,
        lat: -23.593088
    }, {
        lng: -46.663211,
        lat: -23.593767
    }, {
        lng: -46.663045,
        lat: -23.594627
    }, {
        lng: -46.6647399,
        lat: -23.5943471
    }];
    return iguatemijkKML;

}